import { IsOptional } from 'class-validator';
import { DistrictDto } from '../dto';

export class DistrictFilter {
	@IsOptional()
	districts?: string | null;
}
